import ISO3166 from 'iso-3166-1-alpha-2';
import { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { UseGetMyBuyerMatchingListing, UseAddToFavorite, useGetUserSubscription, useGetMyBuyerListing } from "../../../../api/buyer";
import { useGetTypeUser } from "../../../../api/user";
import { useKeycloakHooks } from "../../../../hooks/keycloak";
import SellerSecondMenu from '../../../../layouts/second-headers/seller';
import BuyerSecondMenu from '../../../../layouts/second-headers/buyer';
import { LoaderCommon } from "../../../../widget/loader";
import '../../buyer.scss';
import { addToArray, paginate } from '../../../../utils/outils';
import SeeBtn from '../../../../components/seeBtn';
import { useMutation, useQuery } from 'react-query';
import SellerListing from '../../../seller/listing';
import { UseGetMySellerListing } from '../../../../api/seller';

interface ISellerData {
    id: string;
    matching: number;
    isFavorite: boolean;
    isUnlock: boolean;
    seller: {
        id: number;
        stage: string;
        company_reason: string;
        location: string;
        founded: string;
        company_size: string;
        value_driver: string;
        valuation: string;
        profitability: string;
        targeted_industry: string[];
        software_solution: string[];
        featured_solution: string[];
        user_account: {
            is_premium: boolean;
        }
    }


}


export default function MyMatchingListing() {
    const navigate = useNavigate();

    const { keycloak, tokenInfo, initialized } = useKeycloakHooks();

    const [enableCheckSubscription, setEnabledCheckSubscription] = useState(true);
    const { data: checkSubscription, refetch: refetchCheck, isLoading } = useGetUserSubscription(enableCheckSubscription);

    const [enabledMySellerListing, setEnabledMySellerListing] = useState(false);
    const { data: sellerListing } = UseGetMySellerListing(enabledMySellerListing);

    const [enabledGetMyBuyerListing, setEnabledGetMyBuyerListing] = useState(false);
    const { data: buyerListing } = useGetMyBuyerListing(enabledGetMyBuyerListing);

    const [savedplanType, setplanType] = useState<number|null>(null);

    const [enabled, setEnabled] = useState(false);
    const { data: userRoles, isLoading: userRolesLoading } = useGetTypeUser(tokenInfo, enabled);
    const [enabledGetMyBuyer, setEnabledGetMyBuyer] = useState(false);
    const { data: myBuyer } = useGetMyBuyerListing(enabledGetMyBuyer);


    const [params, setParams] = useState({
        location: [] as string[],
        horizontal: [] as string[],
        vertical: [] as string[],
    });

    const mutGetMatching = useMutation({
        mutationFn: UseGetMyBuyerMatchingListing,
        onSuccess: (data) => {
            if (data.status === 200) {
                refetchCheck();
            } else {
                refetchCheck();
            }
        }
    });

    const fetchMyMatching = async (savedplanType: any, params: any): Promise<any> => {
        const dataParam = {
            planType: savedplanType,
            params: params
        };
        const response = await mutGetMatching.mutateAsync(dataParam);
        return response;
    };

    const useMyBuyerMatchingListing = (savedplanType: any, enabled: boolean) => {
        const { data, isFetched, refetch, isLoading } = useQuery(
            ['myBuyerMatching', savedplanType],
            () => fetchMyMatching(savedplanType, {}),
            {
                enabled: enabled
            }
        );
        return {
            data: data,
            isFetched: isFetched,
            refetch: refetch,
            isLoading: isLoading
        };
    };

    useEffect(() => {
        if (tokenInfo?.user_uuid) {
            setEnabled(true);
            setEnabledMySellerListing(true);
            setEnabledGetMyBuyerListing(true);
        }
    }, [myBuyer, tokenInfo?.user_uuid, userRoles])

    useEffect(() => {
        if (sellerListing) {
            setEnabledMySellerListing(false);
        }
    }, [sellerListing])

    useEffect(() => {
        if (buyerListing) {
            setEnabledGetMyBuyerListing(false);
        }
    }, [buyerListing])

    const [uniqueLocations, setUniqueLocations] = useState<string[]>([]);
    const [uniqueIndustries, setUniqueIndustries] = useState<string[]>([]);
    const [uniqueSolutions, setUniqueSolutions] = useState<string[]>([]);
    const [isMyBuyerListingFetched, setIsMyBuyerListingFetched] = useState<boolean>(true);

    const [filteredDatas, setFilteredDatas] = useState<Array<any>>([]);
    const [initialMatchings, setInitialMatchings] = useState<Array<ISellerData>>([]);

    useEffect(() => {
        setUniqueLocations(Array.from(new Set(initialMatchings?.map((item: any) => item.seller.location))));
        setUniqueIndustries(Array.from(new Set(initialMatchings?.flatMap((item: any) => item.seller.targeted_industry))));
        setUniqueSolutions(Array.from(new Set(initialMatchings?.flatMap((item: any) => [...item.seller.software_solution, ...item.seller.featured_solution]))));

        refetchCheck();
    }, [initialMatchings]);

    const handleGoToFavorite = () => {
        if (keycloak?.authenticated) { }
        else keycloak?.login();
    }

    // const goToDetails = () => {
    //     myBuyerListing && navigate(`/buyer/listing/details/${myBuyerListing.id}`);
    // };

    const [limitSolution, setLimitSolution] = useState(6);
    const [limitIndustry, setLimitIndustry] = useState(6);
    const [limitLocation, setLimitLocation] = useState(6);
    const [selectedSolution, setSelectedSolution] = useState<Array<string>>([]);
    const [selectedIndustry, setSelectedIndustry] = useState<Array<string>>([]);
    const [selectedLocation, setSelectedLocation] = useState<Array<string>>([]);
    const [searchInput, setSearchInput] = useState<string>('');

    // const uniqueLocations = Array.from(new Set(myBuyerListing.map((item: any) => item.seller.location)));

    // const uniqueIndustries = Array.from(new Set(myBuyerListing.flatMap((item: any) => item.seller.targeted_industry)));

    // const uniqueSolutions = Array.from(new Set(myBuyerListing.flatMap((item: any) => [...item.seller.software_solution, ...item.seller.featured_solution])));



    const [isLocationOpen, setIsLocationOpen] = useState(true);
    const [isSolutionOpen, setIsSolutionOpen] = useState(true);
    const [isIndustryOpen, setIsIndustryOpen] = useState(true);

    const toggleFilterSection = (setState: React.Dispatch<React.SetStateAction<boolean>>) => {
        setState(prevState => !prevState);
    };



    const handleSeeSolution = (action: string) => {
        setLimitSolution(action === '0' ? uniqueSolutions.length : 6);
    };

    const handleSeeIndustry = (action: string) => {
        setLimitIndustry(action === '0' ? uniqueIndustries.length : 6);
    };

    const handleSeeLocation = (action: string) => {
        setLimitLocation(action === '0' ? uniqueLocations.length : 6);
    }

    const handleSelectSolution = (element: string) => {
        setSelectedSolution(addToArray(selectedSolution, element));
    }

    const handleSelectIndustry = (element: string) => {
        setSelectedIndustry(addToArray(selectedIndustry, element));
    }

    const handleSelectLocation = (element: any) => {
        setSelectedLocation(addToArray(selectedLocation, element));
    }



    // const filterBuyerListing = () => {
    //     const param = {
    //         location: selectedLocation,
    //         horizontal: selectedSolution,
    //         vertical: selectedIndustry,
    //     };

    //     const filteredData = myBuyerListing?.filter((el: any) => {
    //         const locationMatch = (!param.location || (Array.isArray(el?.seller.location) && el.seller.location.some((loc: any) => param.location.includes(loc))));
    //         const horizontalMatch = (!param.horizontal || (
    //             Array.isArray(el?.seller.software_solution) &&
    //             Array.isArray(el?.seller.featured_solution) &&
    //             [...el.seller.software_solution, ...el.seller.featured_solution].some(
    //                 (sol: any) => param.horizontal.includes(sol)
    //             )
    //         ));
    //         const verticalMatch = (!param.vertical || (Array.isArray(el?.seller.targeted_industry) && el.seller.targeted_industry.some((ind: any) => param.vertical.includes(ind))));

    //         if (param.location && !param.horizontal && !param.vertical) {
    //             return locationMatch;
    //         } else if (!param.location && param.horizontal && !param.vertical) {
    //             return horizontalMatch;
    //         } else if (!param.location && !param.horizontal && param.vertical) {
    //             return verticalMatch;
    //         } else if (param.location && !param.horizontal && param.vertical) {
    //             return locationMatch || verticalMatch;
    //         } else if (!param.location && param.horizontal && param.vertical) {
    //             return horizontalMatch || verticalMatch;
    //         } else if (param.location && param.horizontal && !param.vertical) {
    //             return verticalMatch || horizontalMatch;
    //         } else {
    //             return locationMatch || horizontalMatch || verticalMatch;
    //         }
    //     });
    //     const finalFilteredData = filteredData.length > 0 ? filteredData : [];
    //     setFilteredDatas(finalFilteredData);

    //     setParams((prevParams) => ({
    //         ...prevParams,
    //         ...(param.location ? { location: param.location } : {}),
    //         ...(param.horizontal ? { horizontal: param.horizontal } : {}),
    //         ...(param.vertical ? { vertical: param.vertical } : {}),
    //     }));
    // };

    const hasFilter = uniqueLocations.length > 0 && uniqueSolutions.length > 0 && filteredDatas.length > 0 && uniqueIndustries.length > 0;

    let shouldDisplayBlock = false;

    if (hasFilter == true) {
        shouldDisplayBlock = true;
    }

    const goToBuyerMatching = () => {
        if(buyerListing && buyerListing?.is_published && !buyerListing?.is_removed)
            navigate("/buyer/listing/my-matching");
    };
    const goToUpgrade = () => {
        navigate("/settings");
    };
    const goToSellerMatching = () => {
        if(sellerListing && sellerListing?.seller && sellerListing?.seller?.is_published && !sellerListing?.seller?.is_removed)
            navigate("/seller/listing/my-matching");
    };
    const resetSellerListing = () => {
        let param = {
            location: [],
            horizontal: [],
            vertical: [],
        }
        setSearchInput('');
        setSelectedSolution([]);
        setSelectedLocation([]);
        setSelectedIndustry([]);

        setParams((prevParams) => ({
            ...prevParams,
            ...param
        }));

        setFilteredDatas(initialMatchings);
    }
    const goToDetails = (id: any) => {
        navigate(`/seller/listing/detail/matching/${id}`);
    };

    const goToEnrollBuyer = () => {
        navigate("/buyer/listing/creation");
    }

    const isOpportunistic = (el: any) => {
        var isOppo = false;

        if (el?.urgency === "Opportunistic" || el?.reason_listing === "I'm opportunistic and open to receive inquiries from potential buyers") {
            isOppo = true
        }

        return isOppo;
    }

    const isPremium = (el: any) => {
        return el?.user_account?.is_premium === true;
    };


    useEffect(() => {
        if (checkSubscription && checkSubscription.data) {
            let subscription = checkSubscription.data.subscription;
            if (subscription) {
                const planType = subscription.type.name === "MOTIVATED BUYER" ? 0 : 1;
                setplanType(planType);
            }
        }
    }, [checkSubscription]);

    useEffect(() => {
        if(savedplanType != null){
            const fetchData = async () => {
                await filterBuyerListing().then((data) => {
                    setInitialMatchings(data);
                    setIsMyBuyerListingFetched(true);
                });
            };

            fetchData();
        }
    }, [savedplanType]);


    const filterBuyerListing = async () => {
        const param = {
            location: selectedLocation,
            horizontal: selectedSolution,
            vertical: selectedIndustry
        };
        const response = await fetchMyMatching(savedplanType, param);

        console.log("responseeeeeee", response)
        const data = response.data;


        const finalFilteredData = data.length > 0 ? data : [];
        const sortedData = finalFilteredData.sort((a:ISellerData, b:ISellerData) => {
            if (a.seller.user_account.is_premium && !b.seller.user_account.is_premium) {
                return -1;
            }
            if (!a.seller.user_account.is_premium && b.seller.user_account.is_premium) {
                return 1;
            }
            return 0;
        });

        setFilteredDatas(sortedData);
        return sortedData;
    }

    const handleSearch = () => {
        if (searchInput.trim() !== '') {
            const filteredData = filteredDatas.filter((el: any) => {
                const country = ISO3166.getCountry(el?.seller.location);
                const locationMatches = country && country.toLowerCase().includes(searchInput.toLowerCase());
                const founded = el?.seller.founded.toLowerCase().includes(searchInput.toLowerCase());
                const stage = el?.seller.stage.toLowerCase().includes(searchInput.toLowerCase());
                const reason = el?.seller.company_reason.toLowerCase().includes(searchInput.toLowerCase());
                const valueDriver = el?.seller.value_driver.toLowerCase().includes(searchInput.toLowerCase());
                const companySize = el?.seller.company_size.toLowerCase().includes(searchInput.toLowerCase());
                const valueAtion = el?.seller.valuation.toLowerCase().includes(searchInput.toLowerCase());
                const profbility = el?.seller.profitability.toLowerCase().includes(searchInput.toLowerCase());
                return locationMatches || founded || stage || reason || valueDriver || companySize || valueAtion || profbility;
            });

            return filteredData || [];
        }

        return [];
    };


    const mutAddToFavorite = useMutation({
        mutationFn: UseAddToFavorite,
        onSuccess: async (data) => {
            await filterBuyerListing();
        }
    })

    const toggleFavorite = async (itemId: any): Promise<any> => {
        const dataParam = {
            idBuyer: itemId,
        }
        const response = await mutAddToFavorite.mutateAsync(dataParam);
        return response;
    }

    return (
        <>
            {(!initialized || !isMyBuyerListingFetched) &&
                <div className='loaderCommon'>
                    <LoaderCommon />
                </div>
            }
            {(initialized && !keycloak?.authenticated) && <Navigate to="/" />}
            {(initialized && keycloak?.authenticated && userRoles?.isBuyer) &&
                <div style={{ paddingTop: "8rem" }} id="my-listing" className="findIsvcontainer programContainer sellerContainer my-listing">

                    {
                        userRoles?.isBuyer ? (
                            <BuyerSecondMenu
                                showSearch={true}
                                searchInput={searchInput}
                                setSearchInput={setSearchInput}
                                handleSearch={handleSearch}
                                handleGoToFavorite={handleGoToFavorite}
                            />
                        ) : (
                            <SellerSecondMenu
                                showSearch={true}
                                searchInput={searchInput}
                                setSearchInput={setSearchInput}
                                handleSearch={handleSearch}
                                handleGoToFavorite={handleGoToFavorite}
                            />
                        )
                    }

                    <div className="filterFindIsv leftTop hScroll">

                        <div className="contentFilter">
                            <div className="block sellerBuyer pb-0 border-0">
                                <div className="sellers active" onClick={() => goToBuyerMatching()}>
                                    <a href="javascript:;">
                                        <span className="icon-sellers"></span>Sellers
                                    </a>
                                </div>
                                <div className="buyer" onClick={() => goToSellerMatching()}>
                                    <a href="javascript:;">
                                        <span className="icon-buyerList"></span>Buyers
                                    </a>
                                </div>
                            </div>
                            {
                                initialMatchings && initialMatchings.length > 0  ? (
                                    <>
                                        <div className="containerBtn block infoProgramContainer border-0">
                                            <button className="btn btn-devinsider cancel" onClick={() => filterBuyerListing()}>Filter</button>
                                            <a className="resetFilter" onClick={() => resetSellerListing()}>
                                                <span className="icon-refresh" />
                                                Reset filter
                                            </a>
                                        </div>
                                        <div className="block">
                                            <h3 className={`title withChild ${isLocationOpen ? 'open' : 'closed'}`} onClick={() => toggleFilterSection(setIsLocationOpen)}>HQ location</h3>
                                            <div className="listCheck">
                                                {
                                                    paginate(uniqueLocations, limitLocation)?.sort((a, b) => {
                                                        const countryA = ISO3166.getCountry(a) || "";
                                                        const countryB = ISO3166.getCountry(b) || "";
                                                        return countryA.localeCompare(countryB);
                                                    })?.map((el: any, index: any) => (
                                                        <div className="custom-control custom-checkbox orange" key={index}>
                                                            <input
                                                                type="checkbox"
                                                                id={`location${index}`}
                                                                className="custom-control-input"
                                                                onChange={() => handleSelectLocation(el)}
                                                                checked={
                                                                    selectedLocation?.find(
                                                                        (selected: any) => selected === el
                                                                    )
                                                                        ? true
                                                                        : false
                                                                }
                                                            />
                                                            <label htmlFor={`location${index}`} className="custom-control-label">
                                                                {ISO3166.getCountry(el)}
                                                            </label>
                                                        </div>
                                                    ))
                                                }
                                                <SeeBtn
                                                    dataSource={uniqueLocations}
                                                    limit={limitLocation}
                                                    seeMoreOrLess={(p: string) => handleSeeLocation(p)}
                                                />
                                            </div>
                                        </div>
                                        <div className="block">
                                            <h3 className={`title withChild ${isSolutionOpen ? 'open' : 'closed'}`} onClick={() => toggleFilterSection(setIsSolutionOpen)}>Solution (Horizontal)</h3>
                                            <div className="listCheck">
                                                {
                                                    paginate(uniqueSolutions, limitSolution)?.sort()?.map((el: any, index: any) => (
                                                        <>
                                                            <div className="custom-control custom-checkbox orange" key={index}>
                                                                <input
                                                                    type="checkbox"
                                                                    id={`solutions${index}`}
                                                                    className="custom-control-input"
                                                                    onChange={() => handleSelectSolution(el)}
                                                                    checked={
                                                                        selectedSolution?.find(
                                                                            (selected: any) => selected === el
                                                                        )
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <label htmlFor={`solutions${index}`} className="custom-control-label">
                                                                    {el}
                                                                </label>
                                                            </div>
                                                        </>
                                                    ))
                                                }
                                                <SeeBtn
                                                    dataSource={uniqueSolutions}
                                                    limit={limitSolution}
                                                    seeMoreOrLess={(p: string) => handleSeeSolution(p)}
                                                />
                                            </div>
                                        </div>
                                        <div className="block">
                                            <h3 className={`title withChild ${isIndustryOpen ? 'open' : 'closed'}`} onClick={() => toggleFilterSection(setIsIndustryOpen)}>Industry (Vertical)</h3>
                                            <div className="listCheck">
                                                {
                                                    paginate(uniqueIndustries, limitIndustry)?.sort()?.map((el: any, index: any) => (
                                                        <>
                                                            <div className="custom-control custom-checkbox orange" key={index}>
                                                                <input
                                                                    type="checkbox"
                                                                    id={`industries${index}`}
                                                                    className="custom-control-input"
                                                                    onChange={() => handleSelectIndustry(el)}
                                                                    checked={
                                                                        selectedIndustry?.find(
                                                                            (selected: any) => selected === el
                                                                        )
                                                                            ? true
                                                                            : false
                                                                    }
                                                                />
                                                                <label htmlFor={`industries${index}`} className="custom-control-label">
                                                                    {el}
                                                                </label>
                                                            </div>
                                                        </>
                                                    ))
                                                }


                                            </div>
                                        </div>
                                        <SeeBtn
                                            dataSource={uniqueIndustries}
                                            limit={limitSolution}
                                            seeMoreOrLess={(p: string) => handleSeeIndustry(p)}
                                        />
                                    </>
                                ) : null
                            }
                        </div>

                    </div>
                    {
                        <div className="container mx-auto minHeightwin sellerRight">
                            <div className="listOfIsv listOfSeller scrollContainer">
                                {savedplanType === 0 ? (
                                    <div className="aboutSection mt-4 pb-5">
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                        eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                                        enim ad minim veniam, quis nostrud exercitation ullamco laboris
                                        nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
                                        reprehenderit in voluptate velit esse cillum dolore eu fugiat
                                        nulla pariatur.
                                        {
                                            !userRoles?.isBuyer && (
                                                <div className="mt-3">
                                                    <a
                                                        className="btn btn-devinsider"
                                                        href="javascript:;"
                                                        onClick={() => goToEnrollBuyer()}
                                                    >
                                                        Enroll now!
                                                    </a>
                                                </div>
                                            )
                                        }
                                    </div>
                                ) : (
                                    <>
                                        <div className="aboutSection mt-4 pb-4">
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                                            enim ad minim veniam, quis nostrud exercitation ullamco laboris
                                            nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
                                            reprehenderit in voluptate velit esse cillum dolore eu fugiat
                                            nulla pariatur.
                                            <a className="btn btn-devinsider mt-3" href="javascript:;" onClick={() => goToUpgrade()}>Upgrade plan</a>
                                        </div>

                                    </>
                                )}

                                <ul className="listSeller">
                                    {searchInput.trim() !== '' ? (
                                        handleSearch()?.length > 0 ? handleSearch() : []).map((el: any, index: any) => (
                                            <li className={`list ${isOpportunistic(el.seller) ? 'opportunistic' : ''} ${isPremium(el.seller) ? 'premium' : ''}`.trim()} key={index}>
                                                <div>
                                                    <div className="logo">
                                                        <span className="icon-building1"></span>
                                                    </div>
                                                    {savedplanType === 0 && (
                                                        <div className='match'>
                                                            <span>match</span>
                                                            <span>{el?.matching < 60 ? '<60' : el?.matching}%</span>
                                                        </div>
                                                    )}

                                                </div>
                                                <div className="desc">
                                                    <h2 className="title">
                                                        {el?.seller?.stage} <span className={`icon-star-${el?.isFavorite ? 'on' : 'off'}`} onClick={() => toggleFavorite(el.id)}></span>
                                                    </h2>
                                                    <div className="about"><span>{el?.seller?.company_reason}</span></div>
                                                    <a className="btn btn-devinsider" href="javascript:;" onClick={() => goToDetails(el?.seller?.id)}>More details</a>
                                                    <ul>
                                                        <li className="item" key={"el_location"}>
                                                            <div>Location</div>
                                                            <span className="ico icon-location"></span>
                                                            <span className="txt">{ISO3166.getCountry(el?.seller?.location)}</span>
                                                        </li>
                                                        <li className="item" key={"el_founded"}>
                                                            <div>Founded</div>
                                                            <span className="ico icon-founded"></span>
                                                            <span className="txt">{el?.seller?.founded}</span>
                                                        </li>
                                                        <li className="item" key={"el_companySIze"}>
                                                            <div>Company size</div>
                                                            <span className="ico icon-compSize"></span>
                                                            <span className="txt">{el?.seller?.company_size}</span>
                                                        </li>
                                                        <li className="item" key={"el_value_driver"}>
                                                            <div>Top value driver</div>
                                                            <span className="ico icon-topValue"></span>
                                                            <span className="txt">{el?.seller?.value_driver}</span>
                                                        </li>
                                                        <li className="item" key={"el_valuation"}>
                                                            <div>Valuation</div>
                                                            <span className="ico icon-valuation"></span>
                                                            <span className="txt">{el?.seller?.valuation}</span>
                                                        </li>
                                                        <li className="item" key={"el_profitability"}>
                                                            <div>Profitability</div>
                                                            <span className="ico icon-profitability"></span>
                                                            <span className="txt">{el?.seller?.profitability}</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </li>
                                        )
                                    ) : (
                                        filteredDatas && filteredDatas.map((el: any, index: any) => (
                                            <li className={`list ${isOpportunistic(el.seller) ? 'opportunistic' : ''} ${isPremium(el.seller) ? 'premium' : ''}`.trim()} key={index}>
                                                <div>
                                                    <div className="logo">
                                                        <span className="icon-building1"></span>
                                                    </div>
                                                    {savedplanType === 0 && (
                                                        <div className='match'>
                                                            <span>match</span>
                                                            <span>{el?.matching < 60 ? '<60' : el?.matching}%</span>
                                                        </div>
                                                    )}

                                                </div>
                                                <div className="desc">
                                                    <h2 className="title">
                                                        {el?.seller?.stage} <span className={`icon-star-${el?.isFavorite ? 'on' : 'off'}`} onClick={() => toggleFavorite(el.id)}></span>
                                                    </h2>
                                                    <div className="about"><span>{el?.seller?.company_reason}</span></div>
                                                    <a className="btn btn-devinsider" href="javascript:;" onClick={() => goToDetails(el?.seller?.id)}>More details</a>
                                                    <ul>
                                                        <li className="item" key={"el_location"}>
                                                            <div>Location</div>
                                                            <span className="ico icon-location"></span>
                                                            <span className="txt">{ISO3166.getCountry(el?.seller?.location)}</span>
                                                        </li>
                                                        <li className="item" key={"el_founded"}>
                                                            <div>Founded</div>
                                                            <span className="ico icon-founded"></span>
                                                            <span className="txt">{el?.seller?.founded}</span>
                                                        </li>
                                                        <li className="item" key={"el_companySIze"}>
                                                            <div>Company size</div>
                                                            <span className="ico icon-compSize"></span>
                                                            <span className="txt">{el?.seller?.company_size}</span>
                                                        </li>
                                                        <li className="item" key={"el_value_driver"}>
                                                            <div>Top value driver</div>
                                                            <span className="ico icon-topValue"></span>
                                                            <span className="txt">{el?.seller?.value_driver}</span>
                                                        </li>
                                                        <li className="item" key={"el_valuation"}>
                                                            <div>Valuation</div>
                                                            <span className="ico icon-valuation"></span>
                                                            <span className="txt">{el?.seller?.valuation}</span>
                                                        </li>
                                                        <li className="item" key={"el_profitability"}>
                                                            <div>Profitability</div>
                                                            <span className="ico icon-profitability"></span>
                                                            <span className="txt">{el?.seller?.profitability}</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </li>
                                        ))
                                    )}
                                </ul>

                            </div>
                        </div>
                    }
                </div >

            }
            {
                (initialized && keycloak?.authenticated && !userRoles?.isBuyer) &&
                <SellerListing showListing={true} />
            }
        </>

    )
}